import { Avatar, Chip } from "@mui/material";
import React from "react";
import {
  AlternateEmailRounded,
  BadgeRounded,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const ProfileDetails = ({ authUser }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center gap-3 px-5 pb-5 border-b">
      {/* Avatar */}
      <Avatar
        alt="profile-pic"
        src={authUser.photo}
        className="bg-primary"
        sx={{ width: 72, height: 72, fontSize: 28 }}
      >
        {!authUser.photo &&
          (authUser.fullName || "U").charAt(0).toUpperCase()}
      </Avatar>

      {/* Name & Role */}
      <div className="flex flex-col items-center gap-1">
        <span className="text-lg font-semibold text-gray-700">
          {authUser.fullName}
        </span>
        <Chip
          label={authUser?.userRole}
          size="small"
          color="primary"
          variant="outlined"
          sx={{ fontSize: 11, height: 22 }}
        />
      </div>

      {/* Username & Email */}
      <div className="flex flex-col gap-1 w-full mt-1">
        <div className="flex items-center gap-2 text-[13px] text-gray-500">
          <BadgeRounded sx={{ fontSize: 16 }} />
          <span>
            {t("username")}:{" "}
            <span className="font-semibold text-gray-600">
              {authUser.username}
            </span>
          </span>
        </div>
        {authUser.email && (
          <div className="flex items-center gap-2 text-[13px] text-gray-500">
            <AlternateEmailRounded sx={{ fontSize: 16 }} />
            <a
              href={`mailto:${authUser.email}`}
              className="text-primary hover:underline"
            >
              {authUser.email}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileDetails;
